import { Routes, Route, Navigate } from 'react-router-dom'
import { AdminAuthProvider } from './context/AdminAuthContext'
import AdminAuthGuard from './guards/AdminAuthGuard'
import AdminLayout from './components/AdminLayout/AdminLayout'
import LoginPage from './pages/LoginPage/LoginPage'
import DashboardPage from './pages/DashboardPage/DashboardPage'
import OrdersPage from './pages/OrdersPage/OrdersPage'
import OrderDetailPage from './pages/OrderDetailPage/OrderDetailPage'
import BranchesPage from './pages/BranchesPage/BranchesPage'
import BranchDetailPage from './pages/BranchDetailPage/BranchDetailPage'
import UsersPage from './pages/UsersPage/UsersPage'
import UserDetailPage from './pages/UserDetailPage/UserDetailPage'
import AuditLogPage from './pages/AuditLogPage/AuditLogPage'
import ActivityTodayPage from './pages/ActivityTodayPage/ActivityTodayPage'

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route
          element={
            <AdminAuthGuard>
              <AdminLayout />
            </AdminAuthGuard>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/:orderNumber" element={<OrderDetailPage />} />
          <Route path="branches" element={<BranchesPage />} />
          <Route path="branches/:id" element={<BranchDetailPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          <Route path="audit-log" element={<AuditLogPage />} />
          <Route path="activity/today" element={<ActivityTodayPage />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  )
}
